var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-talk-bubble",
      class: {
        "cw-talk-bubble-own-post": _vm.payload.own,
      },
    },
    [
      !_vm.payload.own
        ? _c(
            "div",
            {
              staticClass: "cw-talk-bubble-user",
            },
            [
              _c(
                "div",
                {
                  staticClass: "cw-talk-bubble-avatar",
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.payload.user_avatar,
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.payload.user_name))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-talk-bubble-talktext",
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.payload.content))]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "cw-talk-bubble-talktext-time",
            },
            [
              _c("iso-date", {
                attrs: {
                  date: _vm.payload.chdate,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }